import { Tag } from "@api/models/Tag";
import {MutationTree} from "vuex";
import {TagsState} from "../types/TagsState";

export const mutations: MutationTree<TagsState> = {
    setUsersTags(state, payload: Tag[]) {
        state.usersTags = payload;
    },
    setSessionsTags(state, payload: Tag[]) {
        state.sessionTags = payload;
    }
}